import { motion } from "framer-motion";
import { ChevronRight, Info } from "lucide-react";
import { Button } from "@/components/ui/button";

export const WelcomePage = ({ lang, setLang, onStart, tr }) => (
  <div className="min-h-screen maritime-gradient flex flex-col">
    <header className="w-full py-4 px-6 flex justify-between items-center">
      <div className="flex items-center gap-3">
        <img src="/logo-switch.png" alt="Switch" className="h-10" />
      </div>
      <div className="flex items-center gap-2 bg-white rounded-lg p-1 shadow-sm" data-testid="language-toggle">
        <button 
          className={`flex items-center gap-2 px-3 py-2 rounded-md transition-all ${lang === 'fr' ? 'bg-[#0B2A4A] text-white' : 'hover:bg-gray-100'}`} 
          onClick={() => setLang('fr')} 
          data-testid="lang-fr-btn"
        >
          <span className="text-xl">🇫🇷</span>
          <span className="font-medium text-sm">FR</span>
        </button>
        <button 
          className={`flex items-center gap-2 px-3 py-2 rounded-md transition-all ${lang === 'en' ? 'bg-[#0B2A4A] text-white' : 'hover:bg-gray-100'}`} 
          onClick={() => setLang('en')} 
          data-testid="lang-en-btn"
        >
          <span className="text-xl">🇬🇧</span>
          <span className="font-medium text-sm">EN</span>
        </button>
      </div>
    </header>
    <main className="flex-1 flex items-center justify-center px-4 py-12">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-3xl text-center">
        <div className="flex justify-center mb-8">
          <div className="p-6 bg-[#0B2A4A] rounded-2xl shadow-lg">
            <img src="/logo-switch.png" alt="Switch" className="h-20" />
          </div>
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-[#0B2A4A] mb-4 font-['Tomorrow']">{tr.welcome.title}</h1>
        <p className="text-xl text-[#0B2A4A]/80 font-medium mb-6">{tr.welcome.subtitle}</p>
        <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">{tr.welcome.description}</p>
        <Button size="lg" className="h-14 px-10 text-lg bg-[#0B2A4A] hover:bg-[#0B2A4A]/90" onClick={onStart} data-testid="start-configuration-btn">
          {tr.welcome.start}<ChevronRight className="ml-2 w-5 h-5" />
        </Button>
        <div className="mt-8 p-4 bg-white/60 rounded-lg border border-border max-w-xl mx-auto">
          <div className="flex items-start gap-3">
            <Info className="w-5 h-5 text-[#0B2A4A] flex-shrink-0 mt-0.5" />
            <p className="text-sm text-muted-foreground text-left">{tr.welcome.disclaimer}</p>
          </div>
        </div>
      </motion.div>
    </main>
  </div>
);
